import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ReservedQrStateService } from './reserved-qr-state-service';

@Injectable({
  providedIn: 'root',
})
export class DialogService {
  constructor(private dialog: MatDialog, private router: Router) {}

  openReservedQrPopup(component: any, data: { cardId: string; reservedIdentificationId: string }, currentRoute: string, onFail: () => void): void {
    const dialogRef = this.dialog.open(component, { data });

    dialogRef.afterClosed().subscribe((isUpdated: boolean) => {
      if (isUpdated) {
        ReservedQrStateService.clear();
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentRoute], { state: { reservedIdentificationId: null } });
        });
      } else {
        onFail();
      }
    });
  }
}
